import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ActiveStorageAttachment from "./ActiveStorageAttachment";
import type Organisation from "./Organisation";
import type User from "./User";

export enum Status {
  "completed" = "completed",
  "failed" = "failed",
  "processing" = "processing",
  "staged" = "staged",
}

enum ImportType {
  contact_lists = 1,
  private_influencers = 2,
  private_outlets = 3,
  public_outlets = 4,
  opt_out_emails = 5,
  contact_lists_contacts = 6,
  user_private_influencers = 7,
  bookmark_streams = 8,
  bookmark_external_items = 9,
  instant_insights = 10,
  instant_insights_dashboards = 11,
  instant_insights_widgets = 12,
  instant_insights_google_analytics = 13,
}

@Model()
class OutreachMigratorImport extends ApplicationRecord {
  static jsonapiType = "outreach_migrator_imports";

  @HasMany() activeStorageAttachments: ActiveStorageAttachment[];

  @Attr({ persist: false }) completedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @BelongsTo() defaultUser: User;

  @Attr() defaultUserId: number;

  @Attr() defaultUserName: string;

  @Attr() error: string;

  @Attr() errorMessage: string;

  @HasMany({ persist: false }) importFiles: ActiveStorageAttachment[];

  @Attr() importType: ImportType;

  @Attr() invalidRecordCount: number;

  @Attr() invalidRecordsCsvUrl: string;

  @Attr() options: Record<string, any>;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() status: Status;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;

  @Attr() userId: number;

  @Attr() validRecordCount: number;
}

export default OutreachMigratorImport;
